import i18n from '@/lib/i18n'

export const ORDER_HISTORY_TITLE = i18n.t('order.history.title')
export const ORDER_HISTORY_TITLE_SHORT = i18n.t('order.history.titleShort')

export const ORDER_HISTORY_FIELDS = {
  deliveryDate: i18n.t('order.history.fields.deliveryDate'),
  orderNo: i18n.t('order.history.fields.orderNo'),
  salesOrderNo: i18n.t('order.history.fields.salesOrderNo'),
  storeCodes: i18n.t('order.history.fields.storeCodes'),
  shipmentStatus: i18n.t('order.history.fields.shipmentStatus'),
  approvalStatus: i18n.t('order.history.fields.approvalStatus'),
}

export const ORDER_HISTORY_ACTIONS = {
  APPROVE: i18n.t('order.history.action.approve'),
  REVOKE_APPROVE: i18n.t('order.history.action.revokeApproval'),
  CANCEL: i18n.t('order.history.action.cancel'),
}

export const ORDER_HISTORY_BULK_ACTIONS = {
  APPROVE: i18n.t('order.history.action.bulkApprove'),
  REVOKE_APPROVE: i18n.t('order.history.action.bulkRevokeApproval'),
  CANCEL: i18n.t('order.history.action.bulkCancel'),
}

export const ORDER_HISTORY_STATUS = {
  UNSHIPPED: i18n.t('order.history.status.unshipped'),
  SHIPPING_PREPARATION: i18n.t('order.history.status.shippingPreparation'),
  SHIPPED: i18n.t('order.history.status.shipped'),
  ERROR: i18n.t('order.history.status.error'),
  CANCELLED_OUT_OF_STOCK: i18n.t('order.history.status.cancelledOutOfStock'),
  PARTIAL_SHIPPING_PREPARATION: i18n.t(
    'order.history.status.partialShippingPreparation'
  ),
  PARTIAL_SHIPPED: i18n.t('order.history.status.partialShipped'),
}
